/**
 *
 * Schedule Block Filtering
 *
 * 
 */

jQuery(document).ready(function ($) {
  jQuery(function ($) {
    // session-tracks-filter
    jQuery('.session-tracks-filter').on('change', function (e) {
      e.preventDefault();
      
      let selectedSession = jQuery(this).val();
      let sessionDesc = jQuery(this).find('option:selected').attr('data-target');

      jQuery('.schedule-active').removeClass('schedule-active').addClass('schedule-hidden');
      jQuery('.'+selectedSession).removeClass('schedule-hidden').addClass('schedule-active');
      jQuery('#session-track-title').text(sessionDesc);
    });

    // schedule date filter
    jQuery('.date-filter').on('change', function (e) {
      e.preventDefault();
      let selectedDate = jQuery(this).val();

      if(selectedDate == 'all-dates') {
        jQuery('.itbl-single-schedule').show();
      } else {
        jQuery('.itbl-single-schedule').hide();
        jQuery('.'+selectedDate).show();
      }
    });
  });

  // Showing/hiding animation

  jQuery('.expand-schedule-section').unbind('click').click(function() {

      jQuery('.schedule-desc-wrap').each(function() {
        let child = jQuery(this).find('.schedule-show-hide-content');
        let expandIcon = jQuery(this).find('.schedule-expand-icon');

        let plusIconSrc = expandIcon.attr('src').replace('minus', 'plus')
        let minusIconSrc = expandIcon.attr('src').replace('plus', 'minus');
      
        if(child.hasClass('alreadyShown')) {
          child.slideUp();
          expandIcon.attr('src', plusIconSrc);
          child.removeClass('alreadyShown');
        } else {
          child.slideDown();
          expandIcon.attr('src', minusIconSrc);
          child.addClass('alreadyShown');
        }
    });
  });

  jQuery('.schedule-items').on('click', '.schedule-desc-wrap', function(){
    let child = jQuery(this).find('.schedule-show-hide-content');
    let expandIcon = jQuery(this).find('.schedule-expand-icon');

    let plusIconSrc = expandIcon.attr('src').replace('minus', 'plus')
    let minusIconSrc = expandIcon.attr('src').replace('plus', 'minus');

    if(child.hasClass('alreadyShown')) {
      child.slideUp();
      expandIcon.attr('src', plusIconSrc);
      child.removeClass('alreadyShown');
    } else {
      child.slideDown();
      expandIcon.attr('src', minusIconSrc);
      child.addClass('alreadyShown');
    }
  });

});